/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  ABR_PRODUCT_NAME_EN,
  ABR_PRODUCT_NAME_ZH,
  isAbrRebrandEnabled,
} from './is-abr-rebrand-enabled';

/** 覆盖 coze-design CDLocale 中的 platform_name（页签标题来源之一） */
export function patchAbrCdLocale<T extends { platform_name?: string }>(
  locale: T,
  isOversea = false,
): T {
  if (!isAbrRebrandEnabled()) {
    return locale;
  }

  return {
    ...locale,
    platform_name: isOversea ? ABR_PRODUCT_NAME_EN : ABR_PRODUCT_NAME_ZH,
  };
}
